import {PlayerBase} from "../../player/player.base";
import {Component, Injector, Pipe, PipeTransform, ViewChild} from '@angular/core';
import {Observable, of, switchMap, takeUntil, timer} from "rxjs";
import {catchError, delay, tap} from "rxjs/operators";
import {lastMap} from "../../rxjs/lastMap";
import {ChromeExtension} from "../../services/Watchdog/ChromeExtension";
import {Log, LogTag} from "../../services/Log";

@Component({
  selector: 'app-html',
  template: '<div #component><iframe #myFrame scrolling="no" style="position: absolute; width: 100%; height: 100%; border:0px; overflow: hidden;"></iframe></div>',
  styleUrls: []
})
export class HtmlComponent extends PlayerBase {
  requiredCheck = false;

  @ViewChild('myFrame', {static: true} ) myFrame;

  constructor(protected  injector: Injector) {
    super(injector);
  }

  load(playerObject: any): Observable<any> {
    let self;
    return super.load(playerObject).pipe(
      switchMap( playerBase => {
        self = playerBase;
        if (this.editMode) {
          this.showMsg(this.playerObject.$.label, this.PREVIEW)
        }
        return of('a');
      }),
      catchError(err => this.logError(err) ),
      switchMap(a => of(self)),
      takeUntil(this.finish$)
    )
  }

  play(): Observable<any> {
    if (this.editMode) {
      return of(null);
    }

    const play$ = super.play();
    return play$.pipe(
      switchMap( a=> {
        const url = this.data.HTML[0].$.src;
        return this.playerService.allowDomain(url);
      }),
      switchMap( r1 => {
        if (this.requiredCheck) {
          this.myFrame.nativeElement.onload = () => {
            if (this.myFrame.nativeElement.contentWindow==null || this.myFrame.nativeElement.contentWindow.length==0) {
              /*???
              setTimeout(()=> {
                if (this.myFrame.nativeElement.contentWindow==null || this.myFrame.nativeElement.contentWindow.length==0) {
                  this.showMsg(this.playerObject?.$.label, this.DEPLOYMENT);
                }
              }, 10000)

               */
            }
          }
        }

        const url = this.data.HTML[0].$.src;
        this.myFrame.nativeElement.src = url;
        return of('play')
      }),
    )
  }

  destroy(): void {
    if (this.myFrame?.nativeElement?.onload!=null) {
      this.myFrame.nativeElement.onload = null;
    }
    super.destroy();
  }
}
